import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Grid,
  TextField,
  Box,
  Skeleton,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';

import 'dayjs/locale/ko';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'

import ProfileUploadContainer from '../../containers/common/fileupload/ProfileUploadContainer';
import HrGradeSelectbox from '../common/form/selectbox/HrGradeSelectbox';
import HrPolicySelectbox from '../common/form/selectbox/HrPolicySelectbox';
import HrDptSelectbox from '../common/form/selectbox/HrDptSelectbox';
import useProfileImage from '../../hooks/useProfileImage';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const ProfileForm = ({ user, formik }) => {
  // 프로필 이미지 URL (axios를 통해 인증 토큰과 함께 로드)
  const profileImageSrc = useProfileImage(user?.usrUuid, user?.profileImg);

  return (
    <>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          p: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid container spacing={1}>
          <Grid xs={3} item textAlign="center">
            {/* <Img alt="complex" src="/static/images/avatar/아이유.jpg" /> */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 1,
              }}
            >
              {profileImageSrc ? (
                <Img
                  style={{
                    width: 200,
                    height: 170,
                  }}
                  alt={user.usrNm}
                  src={profileImageSrc}
                />
              ) : (
                <Skeleton
                  variant="rectangular"
                  width={200}
                  height={170}
                  animation={false}
                />
              )}
            </Box>
            {/* <FileDropZone fileTyp="profile" fileAttrVal1={user.usrUuid} /> */}
            <ProfileUploadContainer
              fileTyp="profile"
              fileAttrVal1={user.usrUuid}
            />
          </Grid>
          <Grid
            item
            xs={9}
            sx={{ flexGrow: 1 }}
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={2}>
              <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="usrNo"
                  name="usrNo"
                  label="사번"
                  value={formik.values.usrNo}
                  onChange={formik.handleChange}
                  error={formik.touched.usrNo && Boolean(formik.errors.usrNo)}
                  helperText={formik.touched.usrNo && formik.errors.usrNo}
                />
              </Grid>
              <Grid item xs={3}>
              <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="usrNm"
                  name="usrNm"
                  label="이름"
                  value={formik.values.usrNm}
                  onChange={formik.handleChange}
                  error={formik.touched.usrNm && Boolean(formik.errors.usrNm)}
                  helperText={formik.touched.usrNm && formik.errors.usrNm}
                />
              </Grid>
              <Grid item xs={4}>
                <HrDptSelectbox
                  formik={formik}
                  name="dptUuid"
                  label="부서"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3}>
                <HrGradeSelectbox
                  formik={formik}
                  name="gradeUuid"
                  label="직급"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
            
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="telNo"
                  name="telNo"
                  label="연락처"
                  value={formik.values.telNo}
                  onChange={formik.handleChange}
                  error={formik.touched.telNo && Boolean(formik.errors.telNo)}
                  helperText={formik.touched.telNo && formik.errors.telNo}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="emlAddr"
                  name="emlAddr"
                  label="이메일"
                  value={formik.values.emlAddr}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.emlAddr && Boolean(formik.errors.emlAddr)
                  }
                  helperText={formik.touched.emlAddr && formik.errors.emlAddr}
                />
              </Grid>
              <Grid item xs={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                  <DatePicker
                    label="입사일"
                    format="YYYY-MM-DD"
                    mask={'____-__-__'}
                    id="entryDt"
                    name="entryDt"
                    value={dayjs(formik.values.entryDt) || new Date()}
                    onChange={(newValue) => {
                      formik.setFieldValue('entryDt', dayjs(newValue));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3}>
                <HrPolicySelectbox
                  formik={formik}
                  name="policyUuid"
                  label="직책"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
            
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <TextField
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrNm"
                  name="postAddrNm"
                  label="우편번호"
                  value={formik.values.postAddrNm}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrNm &&
                    Boolean(formik.errors.postAddrNm)
                  }
                  helperText={
                    formik.touched.postAddrNm && formik.errors.postAddrNm
                  }
                />
              </Grid>
              <Grid item xs={9}>
                <TextField
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  id="postAddrTxt"
                  name="postAddrTxt"
                  label="주소"
                  value={formik.values.postAddrTxt}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.postAddrTxt &&
                    Boolean(formik.errors.postAddrTxt)
                  }
                  helperText={
                    formik.touched.postAddrTxt && formik.errors.postAddrTxt
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 1,
          }}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ProfileForm;
